<template>
  <div class="vacancy-step-testing__q-controls">
    <div class="vacancy-step-testing__q-controls_arrow" @click="downOrder">
      <template v-if="canOrderDown">
        <img :src="require('@/assets/img/test/arrow-down-active.svg')" alt="arrow-down">
      </template>
      <template v-else>
        <img :src="require('@/assets/img/test/arrow-down.svg')" alt="arrow-down">
      </template>
    </div>
    <div class="vacancy-step-testing__q-controls_arrow" @click="upOrder">
      <template v-if="canOrderUp">
        <img :src="require('@/assets/img/test/arrow-up-active.svg')" alt="arrow-up">
      </template>
      <template v-else>
        <img :src="require('@/assets/img/test/arrow-up.svg')" alt="arrow-up">
      </template>
    </div>
    <div @click="deleteQuestion()" class="vacancy-step-testing__q-controls_trash">
      <img :src="require('@/assets/img/test/trash.svg')" alt="trash">
    </div>
  </div>
</template>

<script>
import { toRefs, computed } from '@vue/composition-api';

export default {
  name: 'TestQuestionControls',
  props: {
    question: {
      type: Object,
      required: true,
    },
    lastQuestionOrder: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { question, lastQuestionOrder } = toRefs(props);

    const canOrderUp = computed(() => question.value.order !== 1);
    const canOrderDown = computed(() => question.value.order !== lastQuestionOrder.value);

    function deleteQuestion() {
      emit('deleteQuestion', question.value.id);
    }

    function upOrder() {
      if (!canOrderUp.value) {
        return;
      }

      emit('changeQuestionOrderUp', question.value);
    }

    function downOrder() {
      if (!canOrderDown.value) {
        return;
      }
      emit('changeQuestionOrderDown', question.value);
    }

    return {
      deleteQuestion,
      canOrderUp,
      canOrderDown,
      upOrder,
      downOrder,
    };
  },
};
</script>

<style scoped lang="scss">
.vacancy-step-testing {
  &__q-controls {
    display: flex;
    width: 100px;
    align-items: center;
    gap: 20px;
    margin-left: 30px;
    &_trash {
      cursor: pointer;
    }
    &_arrow {
      cursor: pointer
    }
  }
}
</style>
